import { render } from "./document.vue?vue&type=template&id=4772d8ba&scoped=true"
import script from "./document.vue?vue&type=script&lang=ts"
export * from "./document.vue?vue&type=script&lang=ts"

import "./document.vue?vue&type=style&index=0&id=4772d8ba&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4772d8ba"

export default script